const networks = {
  dfp: 'Ad Exchange',
  facebook: 'Facebook Audience',
  flurry: 'Flurry',
  mopub: 'Mopub'
};


function networkRenamer(type){
  return networks[type];
}

export default networkRenamer;



// WEBPACK FOOTER //
// ./src/networkRenamer.js